// extracted by mini-css-extract-plugin
module.exports = {"column":"styles_column__3oIzq","title":"styles_title__6EQj4"};